// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PreviewTester/components/PreviewContainer.module.css */

@keyframes PreviewContainer_slideDown__wzDCw {
  from {
    opacity: 0;
    transform: translateY(-6px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 300px;
  }
}

.PreviewContainer_previewContainer__45rEq {
  flex: 1 1;
  background-color: #f7fafc;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  min-height: 300px;
  max-height: 100%;
  overflow: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* 👇 Center direct children horizontally (cross-axis in a column flex) */
  align-items: center;
}

/* 👇 Default: every direct child fills the parent width (preserves current behaviour) */
.PreviewContainer_previewContainer__45rEq > * {
  width: 100%;
}

/* 👇 The screens wrapper is allowed to shrink to its own max-width
   and is centred by the parent when narrower than the container. */
.PreviewContainer_previewContainer__45rEq > .verticals,
.PreviewContainer_previewContainer__45rEq > .horizontals {
  width: auto;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.PreviewContainer_selectable__LDy3b {
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}

/* ITEM-UI Screen styles */
.PreviewContainer_previewContainer__45rEq .item-ui-screen {
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-height: 100%;
  overflow: auto;
  -webkit-user-select: text;
          user-select: text;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.8;
}

.PreviewContainer_previewContainer__45rEq .item-ui-screen:not(:last-child) {
  margin-bottom: 12px;
}

.PreviewContainer_previewContainer__45rEq .item-ui-screen[data-is-single="true"] {
  margin-bottom: 0;
}

/* Selection highlighting */
.PreviewContainer_previewContainer__45rEq .item-ui-screen ::selection {
  background-color: #bee3f8;
  color: #2b6cb0;
}

.PreviewContainer_previewContainer__45rEq.PreviewContainer_selectable__LDy3b .item-ui-screen {
  cursor: text;
}

/* ============================================================
   ROW STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 0;
  min-height: 28px;
  flex-wrap: wrap;
  gap: 0;
  transition: background-color 0.15s ease;
  animation: PreviewContainer_fadeInRow__\\+rGwH 0.15s ease;
}

.PreviewContainer_previewContainer__45rEq .row:hover {
  background-color: rgba(247, 250, 252, 0.5);
  border-radius: 4px;
}

.PreviewContainer_previewContainer__45rEq .row.empty-line {
  min-height: 8px;
  padding: 2px 0;
}

.PreviewContainer_previewContainer__45rEq .row.button {
  display: inline-flex;
  padding: 8px 20px;
  background-color: #48bb78;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  min-height: 40px;
  width: auto;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(72, 187, 120, 0.2);
}

.PreviewContainer_previewContainer__45rEq .row.button:hover {
  background-color: #38a169;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(72, 187, 120, 0.3);
}

.PreviewContainer_previewContainer__45rEq .row.button:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(72, 187, 120, 0.2);
}

.PreviewContainer_previewContainer__45rEq .row.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

/* ============================================================
   TOKEN STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .key {
  color: #2b6cb0;
  font-weight: 600;
  margin-right: 4px;
  display: inline-block;
  padding: 0 2px;
  font-family: monospace;
}

.PreviewContainer_previewContainer__45rEq .separator {
  color: #718096;
  margin: 0 4px;
  display: inline-block;
  font-family: monospace;
}

.PreviewContainer_previewContainer__45rEq .value {
  color: #2d3748;
  display: inline-block;
  padding: 0 2px;
  font-family: monospace;
  word-break: break-word;
}

/* ============================================================
   SECTION HEADER STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .section-header {
  color: #2d3748;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 8px;
  display: block;
  padding: 4px 0;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ============================================================
   STYLE TRANSFORMATION CLASSES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .highlight {
  background-color: #fefcbf;
  padding: 0 4px;
  border-radius: 2px;
  transition: background-color 0.2s;
}

.PreviewContainer_previewContainer__45rEq .bold {
  font-weight: 700;
}

.PreviewContainer_previewContainer__45rEq .italic {
  font-style: italic;
}

.PreviewContainer_previewContainer__45rEq .underline {
  text-decoration: underline;
}

.PreviewContainer_previewContainer__45rEq .strikethrough {
  text-decoration: line-through;
}

.PreviewContainer_previewContainer__45rEq .button {
  display: inline-block;
  padding: 6px 16px;
  background-color: #48bb78;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.PreviewContainer_previewContainer__45rEq .button:hover {
  background-color: #38a169;
}

/* ============================================================
   FIELD WRAPPER STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .field-wrapper {
  display: block;
  padding: 2px 0;
}

.PreviewContainer_previewContainer__45rEq .field-wrapper.highlight {
  background-color: #fefcbf;
  padding: 0 4px;
  border-radius: 2px;
}

.PreviewContainer_previewContainer__45rEq .field-wrapper.bold {
  font-weight: 700;
}

.PreviewContainer_previewContainer__45rEq .field-wrapper.italic {
  font-style: italic;
}

.PreviewContainer_previewContainer__45rEq .field-wrapper.underline {
  text-decoration: underline;
}

.PreviewContainer_previewContainer__45rEq .field-wrapper.strikethrough {
  text-decoration: line-through;
}

/* ============================================================
   ITEM WRAPPER STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .item-wrapper {
  border-left: 3px solid #bee3f8;
  padding-left: 12px;
  margin-bottom: 8px;
}

/* ============================================================
   MEDIA WRAPPER STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .media-wrapper {
  display: inline-block;
  margin: 4px 0;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.PreviewContainer_previewContainer__45rEq .media-wrapper:hover {
  transform: scale(1.02);
}

.PreviewContainer_previewContainer__45rEq .preview-image {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  max-width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: block;
  object-fit: cover;
  transition: box-shadow 0.2s ease;
}

.PreviewContainer_previewContainer__45rEq .preview-image:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* ============================================================
   STRUCTURAL TRANSFORMATION STYLES
   ============================================================ */

/* Table styles */
.PreviewContainer_previewContainer__45rEq .previewTable {
  width: 100%;
  border-collapse: collapse;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  margin: 8px 0;
}

.PreviewContainer_previewContainer__45rEq .previewTable th {
  background-color: #f7fafc;
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #e2e8f0;
  font-weight: 600;
  color: #2d3748;
}

.PreviewContainer_previewContainer__45rEq .previewTable td {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  color: #4a5568;
}

.PreviewContainer_previewContainer__45rEq .previewTable tr:nth-child(even) {
  background-color: #f7fafc;
}

.PreviewContainer_previewContainer__45rEq .previewTable tr:hover {
  background-color: #ebf8ff;
}

/* Card styles */
.PreviewContainer_previewContainer__45rEq .previewCardContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 8px 0;
}

.PreviewContainer_previewContainer__45rEq .previewCard {
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.PreviewContainer_previewContainer__45rEq .previewCard:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.PreviewContainer_previewContainer__45rEq .previewCardTitle {
  margin: 0 0 8px 0;
  color: #2d3748;
  font-weight: 700;
  font-size: 16px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.PreviewContainer_previewContainer__45rEq .previewCard p {
  margin: 4px 0;
  font-size: 13px;
  color: #4a5568;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.PreviewContainer_previewContainer__45rEq .cardElWarp {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
}

.PreviewContainer_previewContainer__45rEq .cardElKey {
  font-weight: 600;
  color: #2b6cb0;
  min-width: 80px;
}

.PreviewContainer_previewContainer__45rEq .cardElVal {
  color: #2d3748;
  word-break: break-word;
}

/* List styles */
.PreviewContainer_previewContainer__45rEq .previewList {
  list-style: none;
  padding: 0;
  margin: 8px 0;
}

.PreviewContainer_previewContainer__45rEq .previewListItem {
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  color: #4a5568;
}

.PreviewContainer_previewContainer__45rEq .previewListItem:nth-child(even) {
  background-color: #f7fafc;
}

.PreviewContainer_previewContainer__45rEq .previewListItem:hover {
  background-color: #ebf8ff;
}

.PreviewContainer_previewContainer__45rEq .previewListItem strong {
  color: #2b6cb0;
}

/* ============================================================
   FOR LOOP WRAPPER
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .for-loop-started {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* ============================================================
   TOKEN STYLES - Legacy support
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .token {
  display: inline-block;
  margin: 0 2px;
}

.PreviewContainer_previewContainer__45rEq .token.key {
  color: #2b6cb0;
  font-weight: 600;
}

.PreviewContainer_previewContainer__45rEq .token.separator {
  color: #718096;
  margin: 0 4px;
}

.PreviewContainer_previewContainer__45rEq .token.value {
  color: #2d3748;
}

.PreviewContainer_previewContainer__45rEq .token.section-header {
  color: #2d3748;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 8px;
  display: block;
}

.PreviewContainer_previewContainer__45rEq .token.highlight {
  background-color: #fefcbf;
  padding: 0 4px;
  border-radius: 2px;
}

.PreviewContainer_previewContainer__45rEq .token.bold {
  font-weight: 700;
}

.PreviewContainer_previewContainer__45rEq .token.italic {
  font-style: italic;
}

.PreviewContainer_previewContainer__45rEq .token.underline {
  text-decoration: underline;
}

.PreviewContainer_previewContainer__45rEq .token.strikethrough {
  text-decoration: line-through;
}

/* ============================================================
   SCROLLBAR STYLES
   ============================================================ */

.PreviewContainer_previewContainer__45rEq::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.PreviewContainer_previewContainer__45rEq::-webkit-scrollbar-track {
  background: #f7fafc;
}

.PreviewContainer_previewContainer__45rEq::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.PreviewContainer_previewContainer__45rEq::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

/* ============================================================
   RESPONSIVE STYLES
   ============================================================ */

@media (max-width: 768px) {
  .PreviewContainer_previewContainer__45rEq {
    padding: 12px;
  }

  .PreviewContainer_previewContainer__45rEq .row {
    flex-wrap: wrap;
    gap: 2px;
  }

  .PreviewContainer_previewContainer__45rEq .key,
  .PreviewContainer_previewContainer__45rEq .value {
    font-size: 12px;
  }

  .PreviewContainer_previewContainer__45rEq .row.button {
    padding: 6px 14px;
    font-size: 12px;
    min-height: 34px;
  }

  .PreviewContainer_previewContainer__45rEq .previewCard {
    padding: 12px;
  }

  .PreviewContainer_previewContainer__45rEq .previewCardTitle {
    font-size: 14px;
  }
}

/* ============================================================
   ANIMATIONS
   ============================================================ */

@keyframes PreviewContainer_fadeInRow__\\+rGwH {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes PreviewContainer_pulseButton__jby\\+O {
  0% {
    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(72, 187, 120, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0);
  }
}

.PreviewContainer_previewContainer__45rEq .row.button:focus {
  animation: PreviewContainer_pulseButton__jby\\+O 1.5s ease-out 2;
  outline: none;
}

/* ============================================================
   STYLE PHASE: Text selection indicator
   ============================================================ */

.PreviewContainer_previewContainer__45rEq .item-ui-screen .row {
  position: relative;
  transition:
    background 0.2s ease,
    transform 0.2s ease;
}

.PreviewContainer_previewContainer__45rEq .item-ui-screen .row:hover {
  background: linear-gradient(
    135deg,
    rgba(56, 161, 105, 0.05),
    rgba(47, 133, 90, 0.02)
  );
  border-radius: 4px;
}

/* Small dot indicator on hoverable rows */
.PreviewContainer_previewContainer__45rEq .item-ui-screen .row:hover::before {
  content: "•";
  position: absolute;
  left: -12px;
  color: #38a169;
  font-size: 16px;
  animation: PreviewContainer_dotPulse__Iw043 1.5s ease-in-out infinite;
}

@keyframes PreviewContainer_dotPulse__Iw043 {
  0% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewTester/components/PreviewContainer.module.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE;IACE,UAAU;IACV,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yEAAyE;EACzE,mBAAmB;AACrB;;AAEA,wFAAwF;AACxF;EACE,WAAW;AACb;;AAEA;mEACmE;AACnE;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,uCAAuC;EACvC,wDAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB;qEACmE;EACnE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;iEAEiE;;AAEjE;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;iEAEiE;;AAEjE;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd;qEACmE;AACrE;;AAEA;;iEAEiE;;AAEjE;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC;qEACmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iEAEiE;;AAEjE;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;iEAEiE;;AAEjE;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;iEAEiE;;AAEjE,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB;qEACmE;EACnE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf;qEACmE;AACrE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd;qEACmE;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC;qEACmE;EACnE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;iEAEiE;;AAEjE;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;iEAEiE;;AAEjE;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,+DAAsC;EACtC,aAAa;AACf;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB;;uBAEqB;AACvB;;AAEA;EACE;;;;GAIC;EACD,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,qEAA6C;AAC/C;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF","sourcesContent":["/* PreviewTester/components/PreviewContainer.module.css */\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 300px;\n  }\n}\n\n.previewContainer {\n  flex: 1;\n  background-color: #f7fafc;\n  border-radius: 8px;\n  border: 2px solid #e2e8f0;\n  min-height: 300px;\n  max-height: 100%;\n  overflow: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  /* 👇 Center direct children horizontally (cross-axis in a column flex) */\n  align-items: center;\n}\n\n/* 👇 Default: every direct child fills the parent width (preserves current behaviour) */\n.previewContainer > * {\n  width: 100%;\n}\n\n/* 👇 The screens wrapper is allowed to shrink to its own max-width\n   and is centred by the parent when narrower than the container. */\n.previewContainer > :global(.verticals),\n.previewContainer > :global(.horizontals) {\n  width: auto;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.selectable {\n  cursor: text;\n  user-select: text;\n}\n\n/* ITEM-UI Screen styles */\n.previewContainer :global(.item-ui-screen) {\n  background-color: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-height: 100%;\n  overflow: auto;\n  user-select: text;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: monospace;\n  font-size: 14px;\n  line-height: 1.8;\n}\n\n.previewContainer :global(.item-ui-screen:not(:last-child)) {\n  margin-bottom: 12px;\n}\n\n.previewContainer :global(.item-ui-screen[data-is-single=\"true\"]) {\n  margin-bottom: 0;\n}\n\n/* Selection highlighting */\n.previewContainer :global(.item-ui-screen) ::selection {\n  background-color: #bee3f8;\n  color: #2b6cb0;\n}\n\n.previewContainer.selectable :global(.item-ui-screen) {\n  cursor: text;\n}\n\n/* ============================================================\n   ROW STYLES\n   ============================================================ */\n\n.previewContainer :global(.row) {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 4px 0;\n  min-height: 28px;\n  flex-wrap: wrap;\n  gap: 0;\n  transition: background-color 0.15s ease;\n  animation: fadeInRow 0.15s ease;\n}\n\n.previewContainer :global(.row:hover) {\n  background-color: rgba(247, 250, 252, 0.5);\n  border-radius: 4px;\n}\n\n.previewContainer :global(.row.empty-line) {\n  min-height: 8px;\n  padding: 2px 0;\n}\n\n.previewContainer :global(.row.button) {\n  display: inline-flex;\n  padding: 8px 20px;\n  background-color: #48bb78;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 14px;\n  min-height: 40px;\n  width: auto;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(72, 187, 120, 0.2);\n}\n\n.previewContainer :global(.row.button:hover) {\n  background-color: #38a169;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(72, 187, 120, 0.3);\n}\n\n.previewContainer :global(.row.button:active) {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(72, 187, 120, 0.2);\n}\n\n.previewContainer :global(.row.button:disabled) {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* ============================================================\n   TOKEN STYLES\n   ============================================================ */\n\n.previewContainer :global(.key) {\n  color: #2b6cb0;\n  font-weight: 600;\n  margin-right: 4px;\n  display: inline-block;\n  padding: 0 2px;\n  font-family: monospace;\n}\n\n.previewContainer :global(.separator) {\n  color: #718096;\n  margin: 0 4px;\n  display: inline-block;\n  font-family: monospace;\n}\n\n.previewContainer :global(.value) {\n  color: #2d3748;\n  display: inline-block;\n  padding: 0 2px;\n  font-family: monospace;\n  word-break: break-word;\n}\n\n/* ============================================================\n   SECTION HEADER STYLES\n   ============================================================ */\n\n.previewContainer :global(.section-header) {\n  color: #2d3748;\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 8px;\n  display: block;\n  padding: 4px 0;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* ============================================================\n   STYLE TRANSFORMATION CLASSES\n   ============================================================ */\n\n.previewContainer :global(.highlight) {\n  background-color: #fefcbf;\n  padding: 0 4px;\n  border-radius: 2px;\n  transition: background-color 0.2s;\n}\n\n.previewContainer :global(.bold) {\n  font-weight: 700;\n}\n\n.previewContainer :global(.italic) {\n  font-style: italic;\n}\n\n.previewContainer :global(.underline) {\n  text-decoration: underline;\n}\n\n.previewContainer :global(.strikethrough) {\n  text-decoration: line-through;\n}\n\n.previewContainer :global(.button) {\n  display: inline-block;\n  padding: 6px 16px;\n  background-color: #48bb78;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.previewContainer :global(.button:hover) {\n  background-color: #38a169;\n}\n\n/* ============================================================\n   FIELD WRAPPER STYLES\n   ============================================================ */\n\n.previewContainer :global(.field-wrapper) {\n  display: block;\n  padding: 2px 0;\n}\n\n.previewContainer :global(.field-wrapper.highlight) {\n  background-color: #fefcbf;\n  padding: 0 4px;\n  border-radius: 2px;\n}\n\n.previewContainer :global(.field-wrapper.bold) {\n  font-weight: 700;\n}\n\n.previewContainer :global(.field-wrapper.italic) {\n  font-style: italic;\n}\n\n.previewContainer :global(.field-wrapper.underline) {\n  text-decoration: underline;\n}\n\n.previewContainer :global(.field-wrapper.strikethrough) {\n  text-decoration: line-through;\n}\n\n/* ============================================================\n   ITEM WRAPPER STYLES\n   ============================================================ */\n\n.previewContainer :global(.item-wrapper) {\n  border-left: 3px solid #bee3f8;\n  padding-left: 12px;\n  margin-bottom: 8px;\n}\n\n/* ============================================================\n   MEDIA WRAPPER STYLES\n   ============================================================ */\n\n.previewContainer :global(.media-wrapper) {\n  display: inline-block;\n  margin: 4px 0;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.2s ease;\n}\n\n.previewContainer :global(.media-wrapper:hover) {\n  transform: scale(1.02);\n}\n\n.previewContainer :global(.preview-image) {\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  max-width: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: block;\n  object-fit: cover;\n  transition: box-shadow 0.2s ease;\n}\n\n.previewContainer :global(.preview-image:hover) {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* ============================================================\n   STRUCTURAL TRANSFORMATION STYLES\n   ============================================================ */\n\n/* Table styles */\n.previewContainer :global(.previewTable) {\n  width: 100%;\n  border-collapse: collapse;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 13px;\n  margin: 8px 0;\n}\n\n.previewContainer :global(.previewTable th) {\n  background-color: #f7fafc;\n  padding: 8px 12px;\n  text-align: left;\n  border: 1px solid #e2e8f0;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.previewContainer :global(.previewTable td) {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  color: #4a5568;\n}\n\n.previewContainer :global(.previewTable tr:nth-child(even)) {\n  background-color: #f7fafc;\n}\n\n.previewContainer :global(.previewTable tr:hover) {\n  background-color: #ebf8ff;\n}\n\n/* Card styles */\n.previewContainer :global(.previewCardContainer) {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 8px 0;\n}\n\n.previewContainer :global(.previewCard) {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease;\n}\n\n.previewContainer :global(.previewCard:hover) {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.previewContainer :global(.previewCardTitle) {\n  margin: 0 0 8px 0;\n  color: #2d3748;\n  font-weight: 700;\n  font-size: 16px;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.previewContainer :global(.previewCard p) {\n  margin: 4px 0;\n  font-size: 13px;\n  color: #4a5568;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.previewContainer :global(.cardElWarp) {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 4px 0;\n}\n\n.previewContainer :global(.cardElKey) {\n  font-weight: 600;\n  color: #2b6cb0;\n  min-width: 80px;\n}\n\n.previewContainer :global(.cardElVal) {\n  color: #2d3748;\n  word-break: break-word;\n}\n\n/* List styles */\n.previewContainer :global(.previewList) {\n  list-style: none;\n  padding: 0;\n  margin: 8px 0;\n}\n\n.previewContainer :global(.previewListItem) {\n  padding: 8px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 13px;\n  color: #4a5568;\n}\n\n.previewContainer :global(.previewListItem:nth-child(even)) {\n  background-color: #f7fafc;\n}\n\n.previewContainer :global(.previewListItem:hover) {\n  background-color: #ebf8ff;\n}\n\n.previewContainer :global(.previewListItem strong) {\n  color: #2b6cb0;\n}\n\n/* ============================================================\n   FOR LOOP WRAPPER\n   ============================================================ */\n\n.previewContainer :global(.for-loop-started) {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* ============================================================\n   TOKEN STYLES - Legacy support\n   ============================================================ */\n\n.previewContainer :global(.token) {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.previewContainer :global(.token.key) {\n  color: #2b6cb0;\n  font-weight: 600;\n}\n\n.previewContainer :global(.token.separator) {\n  color: #718096;\n  margin: 0 4px;\n}\n\n.previewContainer :global(.token.value) {\n  color: #2d3748;\n}\n\n.previewContainer :global(.token.section-header) {\n  color: #2d3748;\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.previewContainer :global(.token.highlight) {\n  background-color: #fefcbf;\n  padding: 0 4px;\n  border-radius: 2px;\n}\n\n.previewContainer :global(.token.bold) {\n  font-weight: 700;\n}\n\n.previewContainer :global(.token.italic) {\n  font-style: italic;\n}\n\n.previewContainer :global(.token.underline) {\n  text-decoration: underline;\n}\n\n.previewContainer :global(.token.strikethrough) {\n  text-decoration: line-through;\n}\n\n/* ============================================================\n   SCROLLBAR STYLES\n   ============================================================ */\n\n.previewContainer::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.previewContainer::-webkit-scrollbar-track {\n  background: #f7fafc;\n}\n\n.previewContainer::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 3px;\n}\n\n.previewContainer::-webkit-scrollbar-thumb:hover {\n  background: #a0aec0;\n}\n\n/* ============================================================\n   RESPONSIVE STYLES\n   ============================================================ */\n\n@media (max-width: 768px) {\n  .previewContainer {\n    padding: 12px;\n  }\n\n  .previewContainer :global(.row) {\n    flex-wrap: wrap;\n    gap: 2px;\n  }\n\n  .previewContainer :global(.key),\n  .previewContainer :global(.value) {\n    font-size: 12px;\n  }\n\n  .previewContainer :global(.row.button) {\n    padding: 6px 14px;\n    font-size: 12px;\n    min-height: 34px;\n  }\n\n  .previewContainer :global(.previewCard) {\n    padding: 12px;\n  }\n\n  .previewContainer :global(.previewCardTitle) {\n    font-size: 14px;\n  }\n}\n\n/* ============================================================\n   ANIMATIONS\n   ============================================================ */\n\n@keyframes fadeInRow {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulseButton {\n  0% {\n    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 8px rgba(72, 187, 120, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0);\n  }\n}\n\n.previewContainer :global(.row.button:focus) {\n  animation: pulseButton 1.5s ease-out 2;\n  outline: none;\n}\n\n/* ============================================================\n   STYLE PHASE: Text selection indicator\n   ============================================================ */\n\n.previewContainer :global(.item-ui-screen .row) {\n  position: relative;\n  transition:\n    background 0.2s ease,\n    transform 0.2s ease;\n}\n\n.previewContainer :global(.item-ui-screen .row:hover) {\n  background: linear-gradient(\n    135deg,\n    rgba(56, 161, 105, 0.05),\n    rgba(47, 133, 90, 0.02)\n  );\n  border-radius: 4px;\n}\n\n/* Small dot indicator on hoverable rows */\n.previewContainer :global(.item-ui-screen .row:hover::before) {\n  content: \"•\";\n  position: absolute;\n  left: -12px;\n  color: #38a169;\n  font-size: 16px;\n  animation: dotPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes dotPulse {\n  0% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n  100% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewContainer": `PreviewContainer_previewContainer__45rEq`,
	"selectable": `PreviewContainer_selectable__LDy3b`,
	"fadeInRow": `PreviewContainer_fadeInRow__+rGwH`,
	"pulseButton": `PreviewContainer_pulseButton__jby+O`,
	"dotPulse": `PreviewContainer_dotPulse__Iw043`,
	"slideDown": `PreviewContainer_slideDown__wzDCw`
};
export default ___CSS_LOADER_EXPORT___;
